import axios from '@axios';

export const state = {
  detail: {}

};

export const getters = {
  profileDetail: state => state.detail,
};

export const mutations = {
  GET_PROFILE(state, profile) {
    state.detail = profile;

  },
  UPDATE_PROFILE(state, profile) {
    state.detail = profile;
  }

};

export const actions = {
  async getProfile({ commit }) {
    await axios.get(`/profile`)
      .then((response) => {
        if (response.data.status === 'success') {
          let respondedData = response.data.data;
          let profile = respondedData.profile;
          profile.email = respondedData.email;
          profile.id = respondedData.id;
          commit('GET_PROFILE', profile)
        }
      });
  },

  async updateProfile({ commit, dispatch }, profile) {
    let form = new FormData();
    for(let field in profile){
      form.append(field, profile[field])
    }
    axios.post(`/profile`, form)
    .then((response) => {
      if(response.data.status === 'success'){
        commit('UPDATE_PROFILE', profile);
      }
    })
  }
};
